module.exports = __webpack_public_path__ + "img/logo-ct.da7aa75b.png";